module.exports = __webpack_public_path__ + "img/feature_buy_freespin_cn.73f4c59d.png";